import { z } from "zod/v4"
import { CreatedAt, UpdatedAt } from "../system"
import { DocumentSnapshotLike } from "../../firestore"
import { SubscriptionPlatform } from "./subscription"
import { Scope } from "../coin"

export const SubscriptionCoinGrantStatus = z.enum(["pending", "granted", "failed"])
export type SubscriptionCoinGrantStatus = z.infer<typeof SubscriptionCoinGrantStatus>

export const SubscriptionCoinGrantMeta = z.object({
  subscription_id: z.string().describe("サブスクリプションID"),
  subscription_kind: z.enum(["premium", "premium-plus"]).describe("配布時のサブスクリプション種別"),
  platform: SubscriptionPlatform.describe("プラットフォーム"),
  coin_amount: z.number().describe("配布コイン数"),
  coin_scope: z.nativeEnum(Scope).describe("コインスコープ"),
  status: SubscriptionCoinGrantStatus.describe("配布状態"),
  granted_at: z.number().nullable().describe("配布完了日時（UNIX Timestamp）"),
})

export type SubscriptionCoinGrantMeta = z.infer<typeof SubscriptionCoinGrantMeta>

export const SubscriptionCoinGrantDocumentBody = SubscriptionCoinGrantMeta.extend({
  created_at: CreatedAt,
  updated_at: UpdatedAt,
})

export type SubscriptionCoinGrantDocumentBody = z.infer<typeof SubscriptionCoinGrantDocumentBody>

export type SubscriptionCoinGrantDocument = SubscriptionCoinGrantDocumentBody & {
  id: string
}

export class SubscriptionCoinGrantDocuments {
  static toDocumentData(doc: SubscriptionCoinGrantDocumentBody): object {
    return {
      ...doc,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): SubscriptionCoinGrantDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: doc.id,
      subscription_id: data["subscription_id"],
      subscription_kind: data["subscription_kind"],
      platform: data["platform"],
      coin_amount: data["coin_amount"],
      coin_scope: data["coin_scope"],
      status: data["status"],
      granted_at: data["granted_at"],
      created_at: data["created_at"],
      updated_at: data["updated_at"],
    }
  }
}
